/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ApplyNowCard from "../../../components/corporate/recruitment/ApplyNowCard";
import VacancieDetailsInfo from "../../../components/corporate/recruitment/VacancieDetailsInfo";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../../../components/common/layout/PageLoader";
import { useSelector } from "react-redux";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import { sitemap } from "../../../shared/utils/sitemap";
import Error from "../../../components/common/form/Error";
import Canonical from "../../../components/common/layout/Canonical";

const VacancieDetails = () => {
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [job, setJob] = useState<any[]>([])
    const [jobLoading, setJobLoading] = useState<boolean>(true)
    const [jobError, setJobError] = useState<boolean>(false)
    const params = useParams();
    const navigate = useNavigate();

    const getAdDetail = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.publicAd}${params?.id}/`);

            if (res && res.status === 200) {
                setData(res?.data)
                setLoading(false)
                sitemap()
            }
        } catch (error: any) {
            setIsError(true)
            setLoading(false)
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            console.error("error while fetching ad detail", error);
        }
    }

    const getJobDetail = async () => {
        try {
            setJobError(false)
            setJobLoading(true)
            const res: any = await useAxios.get(`${isLogin ? `${(!!lang ? lang : "en") + url?.createJob}` : `${(!!lang ? lang : "en") + url?.publicJob}`}${params?.jobId}/`);

            if (res && res.status === 200) {
                setJob(res?.data)
                setJobLoading(false)
            }
        } catch (error: any) {
            setJobError(true)
            setJobLoading(false)
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            console.error("error while fetching job details", error);
        }
    }

    useEffect(() => {
        (!!params?.jobId && !!lang) && getJobDetail();
    }, [params?.jobId, isLogin, lang])

    useEffect(() => {
        (!!params?.id && !!lang) && getAdDetail();
    }, [params?.id, lang])

    return (
        <>
            <Canonical />
            <div className="w-full h-full dark:bg-bgDarkDull bg-white">
                <div className="w-full flex flex-col">
                    <div className="h-full w-full">
                        <div className="w-full rounded-b-[50px] h-full min-h-[235px] relative">
                            <div className="absolute top-0 left-0 bottom-0 right-0 rounded-b-[25px] lg:rounded-b-[50px] bg-primary mix-blend-multiply"></div>
                            <img src={require("../../../assets/images/metro-bg.png")} alt="metro-bg" className="w-full rounded-b-[25px] lg:rounded-b-[50px] h-full min-h-[235px]" />
                        </div>

                        <div className="absolute top-0 left-0 right-0 flex items-start justify-between w-full">
                            <RecruitmentHeader />
                        </div>
                    </div>

                    {(!loading && !jobLoading && !isError) && <ApplyNowCard data={data} job={job} />}
                </div>

                <div id="home">
                    {(loading || jobLoading) ?
                        <PageLoader />
                        :
                        <>
                            {(isError || jobError) ? <Error /> : <VacancieDetailsInfo job={job} />}
                        </>
                    }
                </div>
            </div>
        </>
    );
};

export default VacancieDetails;